import { render, staticRenderFns } from "./SupplierData.vue?vue&type=template&id=0fc98395&"
import script from "./SupplierData.vue?vue&type=script&lang=js&"
export * from "./SupplierData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports